import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { ToggledependencyComponent } from '../toggledependency/toggledependency.component';
import { ColDef } from 'ag-grid-community';
import { EditbuttonrenderComponent } from '../editbuttonrender/editbuttonrender.component';
import { MatDialog } from '@angular/material/dialog';
import { DynamicpopupComponent } from '../dynamicpopup/dynamicpopup.component';
import { SentmailwithdetailsComponent } from '../sentmailwithdetails/sentmailwithdetails.component';
import { MatSnackBar } from '@angular/material/snack-bar';
let vm: any;
@Component({
  selector: 'app-tenantmanagement',
  templateUrl: './tenantmanagement.component.html',
  styleUrls: ['./tenantmanagement.component.scss']
})
export class TenantmanagementComponent implements OnInit {
  overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
  overlayNoRowsTemplate = '<span class="ag-overlay-no-rows-center">No data available</span>';
  rowSelection = 'multiple';
  rowHeight = 30;
  gridApi: any;
  gridColumnApi: any;
  tooltipShowDelay = 0;
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.gridApi.sizeColumnsToFit();

  }
  frameworkComponents = {
    editButtonRederer: EditbuttonrenderComponent,
  }
  defaultColDef: ColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    minWidth: 110
  };
  rowData = [];
  columnDefs: any = [
    {
      headerName: "Tenant ID", field: "tenant_id", headerTooltip: "Tenant ID", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Name", field: "name", headerTooltip: "Name", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    },

    // {
    //   headerName: "User Name", field: "user_name", headerTooltip: "User Name", filterParams: {
    //     buttons: ['apply', 'reset'],
    //     closeOnApply: true,

    //   },
    // },
    // {
    //   headerName: "Email for sending details", field: "email_id_sent", headerTooltip: "Email for sending details", filterParams: {
    //     buttons: ['apply', 'reset'],
    //     closeOnApply: true,

    //   },
    // },
    {
      headerName: "Effective From", field: "effective_start_date", headerTooltip: "Effective From", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    },
    {
      headerName: "Effective To", field: "effective_end_date", headerTooltip: "Effective To", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    },
    {
      headerName: "Uploaded On", field: "uploaded_on", headerTooltip: "Uploaded On", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    },
    {
      headerName: "Logs", field: "logs", headerTooltip: "Logs", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    // {
    //   headerName: "Role", field: "role_name", headerTooltip: "Role", filterParams: {
    //     buttons: ['apply', 'reset'],
    //     closeOnApply: true,
    //   },
    // },

    {
      headerName: "Status", field: "enabled_flag", headerTooltip: "Status", pinned: 'right',
      cellRendererFramework: ToggledependencyComponent
    }
    , {
      headerName: "Edit", field: "edit", headerTooltip: "Edit", pinned: 'right', cellRenderer: 'editButtonRederer',

      cellRendererParams: {
        clicked: function (params: any) {
          console.log("params", params)
          vm.openEditpop(params.data);
        },
      }
    },
    // {
    //   headerName: "Share Details", field: "email", headerTooltip: "Email triggering for details sharing", pinned: 'right',
    //   cellRendererFramework: SentmailwithdetailsComponent
    // }

  ]
  constructor(private commonServ: CommonService, private dialog: MatDialog, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    vm = this;
    this.fetchTenanttabledata();
  }
  onCellClicked(item) { }

  fetchTenanttabledata() {
    this.commonServ.fetchTenanttabledata().subscribe((response) => {
      console.log("fetchDocumenttypetabledata", response)
      this.rowData = response
    })
  }
  openEditpop(row: any) {
    console.log('editpop', row)
    const dialogRef = this.dialog.open(DynamicpopupComponent, {
      width: '100%',
      // data: params,
      disableClose: true,
      data: {
        header: 'Edit Tenant',
        type: 'editTenant',
        param: row
      },
      panelClass: 'my-dialog',
    });
    dialogRef.afterClosed().subscribe(data => {
      this.ngOnInit()
      if (data) {
      }
    });
  }


  CreateNewtenant() {
    const dialogRef = this.dialog.open(DynamicpopupComponent, {
      width: '100%',
      // data: params,
      disableClose: true,
      data: {
        header: 'Create New Tenant',
        type: 'createNewTenant'
      },
      panelClass: 'my-dialog',
    });
    dialogRef.afterClosed().subscribe(data => {
      this.ngOnInit()
      if (data) {
      }
    });
  }

}
